export enum FollowUpEnum {
  DELIVERED = "DELIVERED",
  NOT_DELIVERED = "NOT_DELIVERED",
}
